import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectTemplateState } from './project-template.reducer';

export const ProjectTemplateKey = 'projectTemplate';

export const getProjectTemplateState =
  createFeatureSelector<ProjectTemplateState>(ProjectTemplateKey);

export const getProjectTemplates = createSelector(
  getProjectTemplateState,
  (state: ProjectTemplateState) => state.templates,
);

export const getProjectTemplateError = createSelector(
  getProjectTemplateState,
  (state: ProjectTemplateState) => state.apiError,
);

export const getProjectTemplateErrorDescription = createSelector(getProjectTemplateError, (error) =>
  error ? { text: 'Cannot load templates, try again later' } : null,
);

export const getDefaultTemplateId = createSelector(
  getProjectTemplates,
  (templates) => templates?.find((template) => template.isDefaultForNewProjects)?.id || null,
);
